import { createClient, type SupabaseClient } from '@supabase/supabase-js';

import { readSupabaseEnvironment } from './config';

export const supabase: SupabaseClient | null = (() => {
  const env = readSupabaseEnvironment();
  if (!env.url || !env.anonKey) {
    return null;
  }

  return createClient(env.url, env.anonKey, {
    auth: {
      persistSession: true,
      storageKey: 'industrial-audit-auth',
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
})();
